export const MESSAGE_ITEM = {
    WIDTH: 256,
};

export const COMPLEX_IMAGE = {
    WIDTH: MESSAGE_ITEM.WIDTH - 2,
    HEIGHT: 132,
};

COMPLEX_IMAGE.ASPECT_RATIO = COMPLEX_IMAGE.WIDTH / COMPLEX_IMAGE.HEIGHT;

COMPLEX_IMAGE.SQUARE = {
    WIDTH: COMPLEX_IMAGE.WIDTH,
    HEIGHT: COMPLEX_IMAGE.WIDTH,
    ASPECT_RATIO: 1,
};

export const CAROUSEL_MESSAGE = {
    SCROLL_OFFSET: 15,
};

export const AVATAR_CONTAINER = {
    WIDTH: 45,
};

export const CONVERSATION = {
    RIGHT_MARGIN: 10,
};

export const SCROLLBAR = {
    HEIGHT: 15,
};

export const FOOTER = {
    BASE_HEIGHT: 33,
    INPUT_LINE_HEIGHT: 18,
};

export const MESSENGER_BUTTON = {
    DEFAULT_WIDTH: 58,
    DEFAULT_HEIGHT: 58,
    SHADOW_WIDTH: 6,
    VERTICAL_SPACING: 20,
};

export const ICEBREAKER = {
    DEFAULT_WIDTH: 150,
    DEFAULT_HEIGHT: 50,
    SHADOW_WIDTH: 6,
    HORIZONTAL_SPACING: 70,
};

export const WIDGET = {
    WIDTH_LG: 410,
    WIDTH_MD: 350,
    WIDTH_SM: 330,
    WIDTH_XS: '100%',
};

export const HEADER = {
    HEIGHT: 48,
};
